export default __webpack_public_path__ + "static/bottom-44446294b6530c0d7a6488e4de20dbf1.png";